import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../incidentes.css";

const documentos = [
  {
    titulo: "Mesa de Ayuda al Cliente",
    descripcion:
      "Para ofrecer un soporte técnico ágil y consistente, es necesario " +
      "un documento estandarizado que guíe tanto al cliente como al equipo " +
      "de mesa de ayuda. Este formato describirá los canales de contacto " +
      "(teléfono, correo electrónico, portal web), el flujo interno de atención " +
      "(recepción, diagnóstico, solución y cierre), así como los niveles de escalación " +
      "según la complejidad o criticidad del incidente. Así, se garantiza transparencia, " +
      "tiempos de respuesta definidos y una resolución efectiva de los requerimientos del cliente.",
    acciones: [
      { label: "Formato", to: "/documentos-institucionales/mesa-ayuda-cliente" },
    ],
  },
  {
    titulo: "Control de Cambios",
    descripcion:
      "En proyectos en curso, los cambios en alcance, tiempos o recursos pueden afectar " +
      "la calidad, el presupuesto y los plazos de entrega. Para gestionar adecuadamente " +
      "estas variaciones, es imprescindible contar con un documento de Control de Cambios " +
      "que registre solicitudes, justificaciones, impacto estimado, autorizaciones y seguimiento. " +
      "Así se mantiene la trazabilidad, la comunicación transparente con stakeholders y se mitigan riesgos de desviación.",
    acciones: [
      { label: "Descargar Formato Control de Cambios", href: "doc/control-de-cambios.docx" },
    ],
  },
  {
    titulo: "Portafolio",
    descripcion: "Descripción:",
    acciones: [
      { label: "Formato", to: "/documentos-institucionales/mesa-ayuda-cliente", disabled: true },
    ],
  },
];

const DocumentosInstitucionales = () => {
  const bucketUrl = process.env.REACT_APP_BUCKET;
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Documentos Institucionales</h1>
        </div>
        <div className="orgproc-grid-3col">
          {documentos.map((doc, index) => (
            <div className="orgproc-card" key={doc.titulo}>
              <div className="orgproc-card-accent"></div>
              <div className="orgproc-card-body">
                <div className="orgproc-eyebrow">Proceso #{index + 1}</div>
                <div className="orgproc-card-title">{doc.titulo}</div>
                <p className="orgproc-card-desc">{doc.descripcion}</p>
                <div className="orgproc-card-actions">
                  {doc.acciones.map((accion) =>
                    accion.href ? (
                      <a
                        className="orgproc-card-btn"
                        href={`${bucketUrl}/${accion.href}`}
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                        key={accion.href}
                      >
                        {accion.label} →
                      </a>
                    ) : accion.disabled ? (
                      <span
                        className="orgproc-card-btn orgproc-card-btn--disabled"
                        aria-disabled="true"
                        key={accion.to}
                      >
                        {accion.label}
                      </span>
                    ) : (
                      <Link className="orgproc-card-btn" to={accion.to} key={accion.to}>
                        {accion.label} →
                      </Link>
                    )
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </>
  );
};

export default DocumentosInstitucionales;

// https://app.diagrams.net/#G1HJo4V6_lXFNTb4mwHiA1kvTAdCy4tg1F
